import { render, staticRenderFns } from "./FileSetField.vue?vue&type=template&id=7bbcf0fa&scoped=true&"
import script from "./FileSetField.vue?vue&type=script&lang=ts&"
export * from "./FileSetField.vue?vue&type=script&lang=ts&"
import style0 from "./FileSetField.vue?vue&type=style&index=0&id=7bbcf0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbcf0fa",
  null
  
)

export default component.exports